<script setup lang="ts">
import GbDialog from "@/components/GbDialog.vue";
import GbButton from "@/components/GbButton.vue";
import { usePresentLevelsStore } from "@/presentlevels/presentlevels.store.ts";
import { storeToRefs } from "pinia";
import { getAnalyticsTracker } from '@/tracking/analytics/plugin.ts'
import { onMounted } from 'vue'
import { useLibraryStore } from '@/library/library.store.ts'

const presentLevelsStore = usePresentLevelsStore()

getAnalyticsTracker().getChildContext({
  plw_is_library: false
})

const { errorDisplay } = storeToRefs(presentLevelsStore)
function handleErrorVisibilityChange(visible: boolean) {
  if (!visible) {
    presentLevelsStore.clearErrorDisplay()
  }
}

onMounted(() => {
  useLibraryStore().fetchFoldersForPLSubjectSummaries()
})
</script>

<template>
  <div class="container">
    <router-view />
    <GbDialog
      dialog-id="error-modal"
      :visible="!!errorDisplay"
      @update:visible="handleErrorVisibilityChange"
      :header="errorDisplay?.displayHeader"
      role="alertdialog"
      aria-describedby="error-message"
      position="top"
      :footer-buttons="true">
      <template #bodyContent>
        <p id="error-message">{{ errorDisplay?.displayBody }}</p>
        <p>If the issue persists, please contact support.</p>
      </template>
      <template #footerButtonRight>
        <GbButton type="button" gbTheme="grayOutlineSecondary" label="OK" @click="presentLevelsStore.clearErrorDisplay()"></GbButton>
      </template>
    </GbDialog>
  </div>
</template>